/**
 * Reporting Manager (RM-only) walkthrough — Team section and read-only review flows.
 * @module features/walkthrough/tours/rmTour
 */

import { t, tourMeta } from '../i18n/walkthroughI18n';
import { navItemPath, navStep, pageStep } from './navTourHelpers';

const meta = tourMeta('rm-team-review');

/** @type {import('../walkthroughTypes').WalkthroughTourDef} */
export const RM_TOUR = {
  id: 'rm-team-review',
  title: meta.title,
  description: meta.description,
  roles: ['rm'],
  prerequisiteRoute: navItemPath('review-timesheets') ?? '/pm/review-timesheets',
  priority: 20,
  version: 2,
  visible: (_user, ctx) => ctx.rmOnlyNav,
  steps: [
    {
      id: 'nav-team-section',
      targetSelector: '[data-walkthrough="nav-section-project-management"]',
      title: t('walkthrough.rm.teamSection.title'),
      body: t('walkthrough.rm.teamSection.body'),
      placement: 'right',
      visible: (_user, ctx) => ctx.rmOnlyNav,
    },
    navStep('my-timesheet', {
      title: t('walkthrough.rm.myTimesheet.title'),
      body: t('walkthrough.rm.myTimesheet.body'),
    }),
    navStep('review-timesheets', {
      title: t('walkthrough.rm.review.title'),
      body: t('walkthrough.rm.review.body'),
    }),
    navStep('timesheet-logs', {
      title: t('walkthrough.rm.logs.title'),
      body: t('walkthrough.rm.logs.body'),
    }),
    pageStep('review-read-only-hint', {
      title: t('walkthrough.rm.readOnly.title'),
      body: t('walkthrough.rm.readOnly.body'),
      placement: 'bottom',
      targetSelector: '[data-walkthrough="review-read-only-hint"]',
    }),
  ],
};
